import { Model } from "@tailflow/laravel-orion/lib/model";

export class UserType extends Model<{
  name: string;
  description: string;
  created_at: string;
  updated_at: string;
}> {
  public $resource(): string {
    return "user-types";
  }
}
